import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  { q: "O Delivery Maracás atende toda a cidade?", a: "Sim! Atendemos toda a área urbana de Maracás-BA e bairros próximos. Basta informar seu endereço no app para ver as lojas disponíveis." },
  { q: "Como faço para baixar o app?", a: "O app está disponível gratuitamente na App Store (iPhone) e na Google Play (Android). É só tocar nos botões de download aqui na página." },
  { q: "Quais formas de pagamento são aceitas?", a: "Você pode pagar pelo app com cartão, Pix ou na entrega (dinheiro/maquininha), conforme a loja escolhida." },
  { q: "Sou lojista, como cadastro meu negócio?", a: "Clique em 'Cadastre sua loja' para acessar o Painel do Lojista, onde você cria sua conta e monta seu catálogo. Não cobramos taxa de adesão." },
  { q: "Quanto tempo leva a entrega?", a: "O tempo varia conforme a loja e sua localização, mas nosso foco é entrega rápida. Você acompanha tudo em tempo real pelo app." },
];

export const Faq = () => (
  <section id="faq" className="bg-white py-24 md:py-32" data-testid="faq-section">
    <div className="mx-auto grid max-w-8xl gap-12 px-5 md:grid-cols-[0.8fr_1.2fr] md:px-10">
      <div>
        <p className="mb-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-maraca-teal">Dúvidas</p>
        <h2 className="font-display text-4xl font-extrabold tracking-tight text-maraca-navy md:text-5xl lg:text-6xl">
          Perguntas frequentes
        </h2>
      </div>

      <Accordion type="single" collapsible className="w-full">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b border-black/10" data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="py-5 text-left font-display text-lg font-bold text-maraca-navy hover:text-maraca-teal hover:no-underline md:text-xl">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-base leading-relaxed text-maraca-navy/70">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
